import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function exportXlsx(filename, sheetName, headers, rows) {
  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, (sheetName || "Feuille").slice(0, 31));
  XLSX.writeFile(wb, filename);
}

export function exportPdf(filename, title, subtitle, headers, rows) {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(16);
  doc.setTextColor(20);
  doc.text(title, 14, 16);
  if (subtitle) {
    doc.setFontSize(10);
    doc.setTextColor(120);
    doc.text(subtitle, 14, 22);
  }
  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: subtitle ? 28 : 22,
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [13, 43, 94], textColor: 255 },
    alternateRowStyles: { fillColor: [245, 245, 245] },
  });
  doc.save(filename);
}

export function exportWorkbook(filename, sheets) {
  const wb = XLSX.utils.book_new();
  sheets.forEach((s) => {
    const ws = XLSX.utils.aoa_to_sheet([s.headers, ...s.rows]);
    XLSX.utils.book_append_sheet(wb, ws, (s.name || "Feuille").slice(0, 31));
  });
  XLSX.writeFile(wb, filename);
}

export function exportPdfSections(filename, title, subtitle, sections) {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(16);
  doc.setTextColor(20);
  doc.text(title, 14, 16);
  if (subtitle) {
    doc.setFontSize(10);
    doc.setTextColor(120);
    doc.text(subtitle, 14, 22);
  }
  let y = subtitle ? 28 : 22;
  sections.forEach((sec) => {
    if (y > 175) { doc.addPage(); y = 20; }
    doc.setFontSize(12);
    doc.setTextColor(13, 43, 94);
    doc.text(sec.heading, 14, y);
    autoTable(doc, {
      head: [sec.headers],
      body: sec.rows.length ? sec.rows : [["—"]],
      startY: y + 3,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [13, 43, 94], textColor: 255 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
    });
    y = doc.lastAutoTable.finalY + 10;
  });
  doc.save(filename);
}
